export enum MedicationStockReason {
  INITIAL_STOCK = 'INITIAL_STOCK',
  RESTOCK = 'RESTOCK',
  MED_ADMIN = 'MED_ADMIN',
  WASTE = 'WASTE',
  STOCK_COUNT = 'STOCK_COUNT',
  DISCONTINUED = 'DISCONTINUED',
  NOT_ADMINISTERED = 'NOT_ADMINISTERED',
  RECONCILIATION = 'RECONCILIATION'
}

export enum DiscrepancyStatus {
  PENDING = 'PENDING',
  RECONCILED = 'RECONCILED',
  INVESTIGATING = 'INVESTIGATING'
}

export interface StockRecordWitness {
  userId: string
  witnessedAt: string
}

export interface StockRecordDiscrepancy {
  amount: number
  status: DiscrepancyStatus
  carerReason?: string
  reason?: string
}

export interface StockRecordListItem {
  id: string
  date: string
  recordedBy: string
  action: MedicationStockReason
  notes?: string | string[]
  expectedStock: number
  stockCount: number
  quantityChange: number
  unit: string
  witnessed: boolean
  witnesses?: StockRecordWitness[]
  discrepancy?: StockRecordDiscrepancy
}

export type ResidentMedication = {
  patternId: string
  residentMedicationId: string
  medicationName: string
  dose: string
  route: string
  currentStockLevel: number
  unit: string
  stockAlertLevel: number
  isBelowThreshold: boolean
  lastStockRecordDate: string
  lastStockCountDate: string
  daysSinceLastStockCount: Record<string, any>
  controlledDrug: boolean
  secondSignatureRequired: boolean
  discontinued: Record<string, any>
  status: string
}

export type StockRecord = {
  id: string
  date: string
  recordedBy: {
    id: string
    name?: {
      first: string
      last: string
    }
  }
  action: MedicationStockReason
  notes?: string | string[]
  expectedStock: number
  stockCount: number
  quantityChange: number
  unit: string
  witnessed: boolean
  witnesses?: StockRecordWitness[]
  discrepancy?: StockRecordDiscrepancy
}

export type StockLog = {
  id: string
  timeLogged: string
  amount1: number
  amount2: number
  action: string
  actionType: 'stock-count' | 'delivery' | 'disposal' | 'administration' | 'comment'
  title: string
  subtitle?: string
  description?: string
  hasDiscrepancy?: boolean
  isResolved?: boolean
  resolveMessage?: string
  loggedBy: {
    id: string
    name: {
      first: string
      last: string
    }
    picture?: string
  }
  receivedBy?: {
    id: string
    name: {
      first: string
      last: string
    }
  }
  actionedBy?: {
    id: string
    name: {
      first: string
      last: string
    }
  }
  receivedStock?: number
  disposedStock?: number
  receivedDate?: string
  receivedFrom?: string
  actionedDate?: string
  disposalMethod?: string
  deleted?: boolean
}

export type ChartDataPoint = {
  date: string
  stockLevel: number
}

export type StockRecordsResponse = {
  records: StockRecord[]
  chartData: ChartDataPoint[]
  total: number
  hasActivity: boolean
  suggestedActivityDate?: string
}

export type MedicationDetail = {
  id: string
  name: string
  stockQuantityType: string
  quantityType: string
  currentStock: number
  expectedStock: number
  lowStockThreshold: number
  stockLogs?: StockLog[]
}

export type ResidentMedicationsResponse = {
  scheduledMedications: ResidentMedication[]
  prnMedications: ResidentMedication[]
  discontinuedMedications: ResidentMedication[]
  medicationDetail?: MedicationDetail
}
